<template>
    <div>
        <collegeBanner></collegeBanner>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <CollegeSideNavLayout></CollegeSideNavLayout>
                </div>
                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <h1>Quiz</h1>
                                </div>
                                <div class="row padd-top-10">
                                    <div class="col-md-12">
                                        <div class="quizTable">
                                            <table>
                                                <thead>
                                                <tr>
                                                    <th class="sno">#</th>
                                                    <th class="quizName">Quiz Name</th>
                                                    <th class="noQuse">No. of Questions</th>
                                                    <th class="tMarks" >Total Marks</th>
                                                    <th class="time">Time Limit</th>
                                                    <th class="timetaken">Quiz Taken By Students</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(quiz, index) in quizes">
                                                    <td class="sno">{{index + 1}}</td>
                                                    <td>{{quiz.name}}</td>
                                                    <td>{{quiz.questions}}</td>
                                                    <td>{{quiz.marks}}</td>
                                                    <td>{{quiz.time}}</td>
                                                    <td>
                                                        <a href="/dashboard/quiz-stats">{{quiz.quiztaken}}</a>
                                                    </td>

                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CollegeSideNavLayout from '../../components/CollegeSideNavLayout.vue'
    import collegeBanner from '../../components/collegeBanner'

    export default {
        components:{
            CollegeSideNavLayout,
            collegeBanner
        },
        data(){
            return{
                quizes: [
                    {
                        "name": "Participles and Participle Phrases",
                        "questions": "20",
                        "marks": "40",
                        "time": "40 minutes",
                        "quiztaken": "35",
                    },
                    {
                        "name": "Second Industrial Revolution",
                        "questions": "10",
                        "marks": "30",
                        "time": "30 minutes",
                        "quiztaken": "28",
                    },
                    {
                        "name": "Weather and Seasons",
                        "questions": "15",
                        "marks": "30",
                        "time": "30 minutes",
                        "quiztaken": "25",
                    }
                ]
            }
        },
        mounted(){

        },
        methods:{

        }
    }
</script>

<style scoped>
    .sno{
        width: 5%;
        text-align: center;
    }
    .quizName{
        width: 30%;
    }
    .noQuse, .tMarks, .time, .timetaken{
        width: 10%;
    }
    .quizTable{
        padding: 0 15px 15px;
    }
    table {
        width: 100%;
        border-collapse: collapse;
    }
    /* Zebra striping */
    tr:nth-of-type(odd) {
        background: #f7f7f7;
    }
    th {
        background: #00a0e3;
        color: #fff;
        font-weight: 500;
        padding: 10px 8px;
    }
    td, th {
        padding: 10px 8px;
        border: 1px solid #eee;
        text-align: left;
    }
    .view-all{
        float: left;
    }
    @media
    only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px)  {

        /* Force table to not be like tables anymore */
        table, thead, tbody, th, td, tr {
            display: block;
        }

        /* Hide table headers (but not display: none;, for accessibility) */
        thead tr {
            position: absolute;
            top: -9999px;
            left: -9999px;
        }

        tr { border: 1px solid #ccc; }

        td {
            /* Behave  like a "row" */
            border: none;
            border-bottom: 1px solid #eee;
            position: relative;
            padding-left: 50%;
        }

        td:before {
            /* Now like a table header */
            position: absolute;
            /* Top/left values mimic padding */
            top: 6px;
            left: 6px;
            width: 45%;
            padding-right: 10px;
            white-space: nowrap;
        }

        /*
        Label the data
        */
        td:nth-of-type(1):before { content: "S.No"; }
        td:nth-of-type(2):before { content: "Quiz Name"; }
        td:nth-of-type(3):before { content: "No. of Questions"; }
        td:nth-of-type(4):before { content: "Total Marks"; }
        td:nth-of-type(5):before { content: "Time Limit"; }
        td:nth-of-type(6):before { content: "Quiz Taken By Students"; }
    }
</style>